import React from "react";
import Foodora from "../../assets/images/socials/foodora.webp";
import Liferando from "../../assets/images/socials/liferando.webp";
import Website from "../../assets/images/socials/syleniainc.webp";

const socials = [
  {
    id: 1,
    href: "https://www.foodora.at/",
    img: Foodora,
    name: Foodora
  },
  {
    id: 2,
    href: "https://www.lieferando.at/",
    img: Liferando,
    name: Liferando
  },
  {
    id: 3,
    href: "https://syleniainc.com",
    img: Website,
    name: Website
  }
];

const FooterSocials = () => {

  return (
    <ul className="footer__socials">
      {socials.map(social =>
        <li key={social.id}>
          <a
            href={social.href}
            target="_blank"
            rel="noreferrer"
            aria-label={social.name}
          >
            <span aria-hidden="true">{social.name}</span>
            <img src={social.img} alt="" aria-hidden="true" width={50}
              height={50} />
          </a>
        </li>)}
    </ul>
  );
}

export default FooterSocials
